import { Injectable } from '@angular/core';
import { type CanActivate, type ActivatedRouteSnapshot, Router } from '@angular/router';
import { Actions, ofActionDispatched, Store } from "@ngxs/store";
import * as FlatActions from '@medsurf/flat-actions';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RedirectControlGuard implements CanActivate {
  constructor(public store: Store,
              public actions$: Actions,
              public router: Router) {
  }

  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    const idSlug = next.paramMap.get('idSlug');
    if (idSlug) {
      return new Promise((resolve) => {
        this.actions$.pipe(ofActionDispatched(FlatActions.NodeControlActions.GetRouteByIdSuccess), take(1)).subscribe(({ route }) => {
          if (route) this.router.navigateByUrl(route);
          resolve(true);
        });
        this.store.dispatch(new FlatActions.NodeControlActions.GetRouteById(idSlug));
      });
    } else {
      return true
    }
  }
}
